module.exports = __webpack_public_path__ + "static/img/gaoxiao_1.4f6edfb7.png";